<!-- prettier-ignore -->

<button
  class="chat__button"
  type="button"
  [attr.aria-label]="'Cargando' | translate"
>
  <ci-icon name="loader-debounce" scale="1x"></ci-icon>
</button>
